import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export interface ToastData {
  title: string;
  message: string;
  type: 'error' | 'success';
}

@Component({
  selector: 'app-custom-toaster',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="toast-container" [ngClass]="data.type">
      <div class="toast-content">
        <div class="icon-container">
          <mat-icon *ngIf="data.type === 'error'">error</mat-icon>
          <mat-icon *ngIf="data.type === 'success'">check_circle</mat-icon>
        </div>
        <div class="text-container">
          <div class="title">{{ data.title }}</div>
          <div class="message">{{ data.message }}</div>
        </div>
        <div class="close-container" (click)="close()">
          <mat-icon>close</mat-icon>
        </div>
      </div>
      <div class="progress-bar-container">
        <div class="progress-bar" [ngStyle]="{'animation-duration': duration + 'ms'}"></div>
      </div>
    </div>
  `,
  styleUrls: ['./custom-toaster.component.scss']
})
export class CustomToasterComponent implements OnInit, OnDestroy {
  duration = 3000;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ToastData,
    private snackBarRef: MatSnackBarRef<CustomToasterComponent>
  ) {}

  ngOnInit() {
    // The duration should match the MatSnackBar configuration.
    // If not accessible easily, we default to 3000ms.
  }

  ngOnDestroy() {
  }

  close() {
    this.snackBarRef.dismiss();
  }
}
